// extracted by mini-css-extract-plugin
export default {"buttons":"DeletePropertyValueModal_buttons__RQ8eY","errorMessage":"DeletePropertyValueModal_errorMessage__tV3wC"};